// Kurskontingent je Tarif (16.10.2026, backend/kurskontingent.py): eine Zeile in der Lead-Ansicht (Reiter Trainingshistorie)
// „Kurse diese Woche: x von y (z nachholbar)“. Nur Anzeige — gerechnet wird in mitglied_regeln.kontingent_stand.
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CalendarCheck } from 'lucide-react';
import { kurskontingentAPI } from '@/lib/api';

const GRUND = { team: 'Team – kein Limit', unbegrenzt: 'Tarif ohne Limit', tarif_unbekannt: 'Tarif unbekannt – kein Limit', ohne_vertrag: 'ohne Vertrag – kein Kontingent' };

export default function KurskontingentZeile({ leadId }) {
  const navigate = useNavigate();
  const [stand, setStand] = useState(null);

  useEffect(() => {
    let aktiv = true;
    kurskontingentAPI.stand(leadId).then((r) => { if (aktiv) setStand(r.data); }).catch(() => { /* Anzeige ist Beiwerk */ });
    return () => { aktiv = false; };
  }, [leadId]);

  if (!stand) return null;
  const ueber = !stand.unbegrenzt && stand.genutzt > stand.erlaubt;
  return (
    <div className="flex flex-wrap items-center gap-2 text-sm rounded-md border border-border/60 px-3 py-2" data-testid="kurskontingent-zeile">
      <CalendarCheck className="h-4 w-4 text-muted-foreground" />
      {stand.unbegrenzt ? (
        <span>Kurse diese Woche: {stand.genutzt} <span className="text-muted-foreground">({GRUND[stand.grund] || 'kein Limit'})</span></span>
      ) : (
        <span>
          Kurse diese Woche: <b>{stand.genutzt} von {stand.je_woche}</b>
          {stand.nachholbar ? <span className="text-muted-foreground"> ({stand.nachholbar} nachholbar)</span> : null}
          {stand.warteliste ? <span className="text-muted-foreground"> · {stand.warteliste} auf der Warteliste</span> : null}
        </span>
      )}
      {ueber && <span className="text-[11px] rounded border border-amber-500 px-1 text-amber-700 dark:text-amber-400">über Kontingent</span>}
      {stand.anfragen_offen > 0 && (
        <button type="button" className="ml-auto text-xs underline" onClick={() => navigate('/freigabe')}>
          {stand.anfragen_offen} Kursanfrage{stand.anfragen_offen === 1 ? '' : 'n'} offen
        </button>
      )}
    </div>
  );
}
